import { Configuration } from '@/types';
import ConfigurationTreeView from '@/components/configuration/TreeView.vue';
import { TreeViewConstants } from '@/types/constants/TreeViewConstants';

const ExternalAPIKeyManagement = () =>
  import(
    /* webpackChunkName: "ExternalAPIKeyManagement" */
    '@/views/configuration/user/ExternalAPIKeyManagement.vue'
  );

const meta = {
  layout: 'TreeView',
  treePath: 'externalAPIKeyManagement',
  treeViewKey: TreeViewConstants.Keys.Configuration
};

export const ExternalAPIKeyManagementRoutes = [
  {
    ...Configuration.ExternalAPIKeyManagement.Management,
    components: {
      default: ExternalAPIKeyManagement,
      treeView: ConfigurationTreeView
    },
    meta
  }
];
